import React, { useEffect } from "react";
import { useTranslate } from "../../../../components/TranslationText";
import { TranslationKeys } from "../../../../constants/TranslationKeys";
import EahsForm from "../../../../components/EahsForm";
import FormCheckbox from "../../../../components/FormInputs/FormCheckbox";
import { useFormContext } from "react-hook-form";
import { eformTerms } from "../../../../common/cssclasses";

const IBCTermsSection = ({
    termsList,
    isReadOnly,
    isNotNewRequest = false
}) => {
    const { translate } = useTranslate();
    const { setValue } = useFormContext();

    const isLocked = isReadOnly || isNotNewRequest;

    useEffect(() => {
        if (isLocked && termsList && termsList.length > 0) {
            termsList.forEach((_, index) => {
                setValue(`term_${index}`, true);
            });
        }
    }, [isLocked, termsList, setValue]);

    if (!termsList || termsList.length === 0) {
        return null;
    }

    return (
        <div id="termsSection">
            <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(TranslationKeys.TERMS, "Terms")}>
                {termsList.map((item, index) => {
                    const name = `term_${index}`;
                    return (
                        <div className={eformTerms} key={index}>
                            <FormCheckbox 
                                name={name}
                                label={item} 
                                disabled={isLocked}
                                required={true}
                            />
                        </div>
                    );
                })}
            </EahsForm>
        </div>
    );
};

export default IBCTermsSection;
